import { jwtDecode, JwtPayload } from "jwt-decode"; 

export interface CustomJwtPayload {
  exp?: number; // Proprietate opțională pentru expirare
}

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded: CustomJwtPayload = jwtDecode(token); // Folosește exportul implicit
    const currentTime = Date.now() / 1000; // Timpul curent în secunde
    return decoded.exp ? decoded.exp > currentTime : false; // Compară expirarea token-ului
  } catch (error) {
    console.error("Eroare la decodarea token-ului:", error);
    return false;
  }
};

export const getUserRole = (): string | null => {
  return localStorage.getItem("role");
};


export const getTokenExpiration = (token: string): number | null => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.exp || null; // Returnează timestamp-ul expirării
  } catch (error) {
    console.error("Eroare la decodificarea token-ului:", error);
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  const expiration = getTokenExpiration(token);
  if (!expiration) return true;
  const currentTime = Date.now() / 1000; // Timpul actual în secunde
  return expiration < currentTime;
};

